module.exports = __webpack_public_path__ + "static/media/thumb.6ecb0ce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/long-road-student-centre/thumb.jpg
// module id = 46
// module chunks = 0